import * as types from '../types';

const INITIAL_STATE = {
  orders: [],
  items: [],
  SubTot: 0,
  Disc: 0,
  Tax: 0,
  Net: 0,
  credit: 0,
  deliveryCharge: 0,
  orderNote: '',
  address: '',
  addressNote: '',
  phoneNumber: '',
  rateDelivery: false,
  reviewOrderId: '',
  rating: 0,
  review: '',
  time: '',
  userLocation: {
    latitude: 31.9454,
    longitude: 35.9284
  },
  initialMapRegion: {
    latitude: 31.9454,
    longitude: 35.9284,
    latitudeDelta: 0.0922,
    longitudeDelta: 0.0421
  },
  showMap: false,
  showCachedMap: false,
  cachedMapKey: 1,
  rateProduct: 0,
  rateService: 0,
  images: [],
  isCameraModalOpen: false,
  hasCameraPermission: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.MYORDERS_UPDATE_STATE:
      return { ...state, ...action.payload };
    case types.MYORDERS_LOAD_ORDERS:
      return { ...state, orders: action.payload };
    case types.MYORDERS_VIEW_ORDER:
      const { SubTot, Disc, Tax, Net, Lines, deliveryCharge } = action.payload.response;
      const { NOTE, ADDRESS, PHONE, LOCATION, DELVTIME, CAN_MODIFY,
        DELVDATE, ADDRESS_NOTE, ISGIFT, RECIPIENT, RECIPIENTMOBILE, PROMOCODE } = action.payload.item;
      return {
        ...state,
        items: Lines,
        SubTot,
        Disc,
        Tax,
        Net,
        deliveryCharge,
        orderNote: NOTE,
        addressNote: ADDRESS_NOTE,
        address: ADDRESS,
        phoneNumber: PHONE,
        time: DELVTIME,
        date: DELVDATE,
        userLocation: { latitude: Number.parseFloat(LOCATION.split(',')[0]), longitude: Number.parseFloat(LOCATION.split(',')[1]) },
        canModify: CAN_MODIFY,
        isGift: ISGIFT,
        recipient: RECIPIENT,
        recipientMobile: RECIPIENTMOBILE,
        promoCode: PROMOCODE
      };
    case types.MYORDERS_RATE_DELIVERY:
      return { ...state, rateDelivery: true, reviewOrderId: action.payload };
    case types.MYORDERS_RESET_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
};
